import { DateOrTimeView, DateView } from '@mui/x-date-pickers';

export const NATURAL_PERSON_CLIENT_TYPE_ID = 1;

// The height of the page without the header and main content padding
export const PAGE_HEIGHT = 'calc(100vh - 128px)';

export enum Messages {
  Required = 'Pflichtfeld',
  InvalidDateFormat = 'Invalid date format',
  GeneralError = 'Es ist ein Fehler aufgetreten',
  ActionSuccessfully = 'Aktion Erfolgreich ausgeführt',
  ReloadSuccessfully = 'Daten wurden erfolgreich aktualisiert',
}

export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DATE_VIEW: DateView[] = ['year', 'month', 'day'];
export const DATE_TIME_VIEW: DateOrTimeView[] = [
  'year',
  'month',
  'day',
  'hours',
  'minutes',
];
